/** @jsx jsx */

import { Fragment } from 'react';

import { jsx, css } from '@emotion/core';
import { Icon } from '@zapier/zinnia-icons';
import { Colors, Spacer } from '@zapier/design-system';

import Link from 'app/common/components/Link';
import { GuideStepItem } from 'app/cli-guide/types';
import { KindType } from 'app/common/types';

const Styles = {
  link: (options: {
    isActive: boolean;
    isCompleted: boolean;
    isSubStep: boolean;
  }) => css`
    align-items: center !important;
    background-color: ${options.isActive && !options.isSubStep
      ? `${Colors.UiPrimaryStrongest} !important`
      : undefined};
    display: flex !important;
    &,
    &:hover {
      color: inherit !important;
    }
    padding: ${options.isSubStep ? '8px' : '12px'}
      ${options.isSubStep ? '66px' : '36px'} !important;
  `,
  root: (options: {
    isActive: boolean;
    isCompleted: boolean;
    isSubStep: boolean;
  }) => css`
    color: ${options.isActive && !options.isSubStep
      ? Colors.PrimeWhite
      : options.isActive && options.isSubStep
      ? Colors.UiPrimaryStrongest
      : undefined};
  `,
};

type Props = {
  step: GuideStepItem;
  isActive: boolean;
  isCompleted?: boolean;
  isSubStep?: boolean;
  kind?: KindType;
  onSelectStep: (step: GuideStepItem) => void;
};

const defaultProps = {
  isActive: false,
  isCompleted: false,
  isSubStep: false,
};

function GuideSidebarItem(props: Props) {
  const { step, isActive, isCompleted, isSubStep, onSelectStep } = props;

  return (
    <li css={Styles.root({ isActive, isCompleted, isSubStep })}>
      <Link
        css={Styles.link({ isActive, isCompleted, isSubStep })}
        href={step.path}
        onClick={() => onSelectStep(step)}
      >
        {isCompleted && (
          <Fragment>
            <Icon
              color={
                isActive && !isSubStep ? 'PrimeWhite' : 'UiPrimaryStrongest'
              }
              name="formCheckCircle"
              size={18}
            />
            <Spacer width={12} />
          </Fragment>
        )}
        <span>{step.title}</span>
      </Link>
    </li>
  );
}

GuideSidebarItem.defaultProps = defaultProps;

export default GuideSidebarItem;
